<style scoped>
label {
    font-weight: 600;
    font-size: 14px;
    color: #7a7a7a;
    text-transform: capitalize;
    margin-bottom: 2px;
}
p {
    border-radius: 3px;
    color: #444444;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
}
.text-view{
  border-bottom: 1px dashed #dddddd;
  padding: 0;
  margin: 8px 48px;
}
</style>
<template>
    <b-row class="text-view" >
      <b-col cols="2" class="mr-0 pl-0 d-flex justify-content-start align-item-start">  <label>{{label}}</label></b-col>
      <b-col class="ml-0 mb-1 pr-0 d-flex justify-content-start align-item-start">
        <p>{{ value }}</p>
      </b-col>
    </b-row>
  
</template>

<script>
export default {
  props: {
    label: {
    },
    value: {
    }
  },
  data() {
    return {
    };
  },
};
</script>